<template>
  <div class="dimmed">
    <div class="group__move--wrap">
      <div class="container">
        <div class="content__header">
          <p class="title">{{ $t('dashboard.groupMove.title') }}</p>
          <div class="group__add"
               :class="{disabled: showNewGroupForm}"
               @click="onNewGroupAddClick">
            <i class="icon icon--plus-black"></i>
            <span>{{ $t('dashboard.groupMove.addGroup') }}</span>
          </div>
        </div>
        <ul class="group-list">
          <li v-if="showNewGroupForm"
            class="list-item new-group"
            :class="{selected: isNewGroupSelected, error: !!newGroupNameError}"
            @click="isNewGroupSelected = true">

            <i class="icon icon--group-icon"></i>
            <div class="input--wrap">
              <input type="text" :placeholder="$t('common.placeHolder.newGroup')" v-model.trim="newGroupName">
              <i v-if="isNewGroupSelected" class="icon icon--close14" @click="newGroupName = ''"></i>
            </div>
            <i v-if="newGroupNameError" class="speech-bubble">
              <i class="arrow bottom center"></i>
              <span class="text">{{ newGroupNameError }}</span>
            </i>
            <i v-if="isNewGroupSelected && !newGroupNameError" class="icon icon--check-white"></i>
          </li>
          <li v-for="(category, index) in categories"
              :key="index"
              :disabled="!movableGroup(category._id)"
              :class="{selected: !isNewGroupSelected && existingGroupName === category._id, immovable: !movableGroup(category._id)}"
              @click="onExistingGroupClick(category._id)"
              class="list-item">
            <i class="icon icon--group-icon"></i>
            <span class="group-name">{{ category._id }}</span>
            <i v-if="existingGroupName === category._id"
               class="icon icon--check-white"></i>
          </li>
        </ul>
        <div class="button--wrap">
          <button class="btn__cancel" @click.stop="$emit('onCloseClick')">{{ $t('common.cancel') }}</button>
          <button class="btn__save"
                  :class="{disabled: !canSubmit}"
                  @click="onSubmitClick">{{ $t('common.move') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardPopup',
  data () {
    return {
      isNewGroupSelected: false,
      showNewGroupForm: false,
      // todo: i18n check
      newGroupName: this.$t('common.placeHolder.newGroup'),
      existingGroupName: ''
    }
  },
  props: [
    'isEditMode',
    'popupContent',
    'categories',
    'selectedApplies'
  ],
  computed: {
    selectedGroupName () {
      return this.isNewGroupSelected ? this.newGroupName : this.existingGroupName
    },
    newGroupNameError () {
      if (this.isNewGroupSelected &&
        this.categories.find(item => item._id.trim() === this.newGroupName)) {
        return this.$t('common.validationErrorText.alreadySameGroupName')
      }
      return null
    },
    canSubmit () {
      return !this.newGroupNameError && this.selectedGroupName.length
    }
  },
  methods: {
    movableGroup (groupName) {
      let isMovable = true
      for (const item of this.selectedApplies) {
        if (item.category === groupName) isMovable = false
      }
      return isMovable
    },
    onNewGroupAddClick () {
      this.showNewGroupForm = true
      this.isNewGroupSelected = true
    },
    onExistingGroupClick (categoryName) {
      this.existingGroupName = categoryName
      this.isNewGroupSelected = false
    },
    onSubmitClick () {
      this.$emit('groupMove', this.selectedGroupName)
    }
  }
}
</script>

<style lang="scss" scoped>
.dimmed{
  .group__move--wrap .container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 500px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding: 30px;
    padding-bottom: 12px;

    .content__header {
      position: relative;
      .title {
        font-size: 15px;
        font-weight: bold;
        line-height: 1;
        color: #2f2f2f;
      }
      .group__add {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        color: #444444;
        height: 32px;
        line-height: 32px;
        border-radius: 15px;
        padding-left: 10px;
        padding-right: 12px;
        box-sizing: border-box;
        cursor: pointer;

        &:hover {
          background-color: #e0e0e0;
        }

        &.disabled {
          pointer-events: none;
          opacity: 0.2;
        }

        .icon {
          vertical-align: sub;
          margin-right: 5px;
        }
      }
    }

    .group-list {
      margin-top: 20px;
      width: 100%;
      height: 240px;
      border-radius: 5px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;
      overflow-y: scroll;
      padding: 18px 27px 18px 8px;
      box-sizing: border-box;

      .list-item {
        border-radius: 18px;
        width: 100%;
        height: 36px;
        line-height: 36px;
        padding-left: 10px;
        padding-right: 10px;
        box-sizing: border-box;
        margin-top: 2px;
        font-size: 13px;
        color: #2f2f2f;
        cursor: pointer;
        position: relative;

        &.on {
          background-color: $brandColor;
          color: #fff;
        }

        &.immovable {
          pointer-events: none;
          opacity: 0.3;
        }

        &.new-group {
          position: relative;
          &.selected {
            border: none;
          }
          &.selected.error {
            background-color: transparent;
            input {
              border: 1px solid $errorColor;
            }
          }

          .input--wrap {
            position: absolute;
            top: 50%;
            left: 39px;
            transform: translateY(-50%);
            width: calc(100% - 80px);
            height: 30px;

            input {
              width: 100%;
              height: 100%;
              vertical-align: top;
              border-radius: 6px;
              background-color: #ffffff;
              box-sizing: border-box;
              padding-left: 12px;
              padding-right: 36px;
              border: solid 1px #bbbbbb;

              &:focus {
                border: solid 1px #289eef;
              }
            }

            .icon--close14 {
              right: 5px;
              padding: 5px;
              background-position: center;
            }
          }

          .speech-bubble {
            display: block;
            padding: 8px 16px;
            position: fixed;
            top: 18px;
            left: 44px;

            .text {
              color: $errorColor;
            }
          }
        }

        &.selected {
          background-color: #289eef;
          color: #fff;
          position: relative;

          .icon--check-white {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
          }
        }

        &:not(.new-group):not(.selected):hover {
          background-color: #e0e0e0;
        }

        &:nth-of-type(1) {
          margin-top: 0;
        }

        .icon:not(.icon--check-white) {
          @include positionYcenter;

          &.icon--group-icon {
            left: 10px;
          }
        }

        .group-name {
          @include textEllipsis;
          display: inline-block;
          padding-left: 29px;
          padding-right: 29px;
          width: 100%;
          box-sizing: border-box;
        }
      }
    }

    .button--wrap {
      margin-top: 12px;
      text-align: center;

      button {
        width: 86px;
        height: 38px;
        border-radius: 20px;
        background-color: #ffffff;
        &.btn__cancel {
          border: solid 1px #bbbbbb;
          &:hover {
            @include hoverStyle;
          }
        }
        &.btn__save {
          margin-left: 5px;
          border: solid 1px $brandColor;
          color: $brandColor;
          &:hover {
            @include hoverStyleColor;
          }
          &.disabled {
            pointer-events: none;
            opacity: 0.2;
          }
        }
      }
    }
  }
}
</style>
